import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  border-radius: 2px;
  color: ${({ theme }) => theme.palette.grey1100};
  position: relative;
  position: relative;
`;

export const Title = styled.span`
  font-size: 28px;
  font-weight: 700;

  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
  }
`;
